<div class="di-majoration"  [class.mode-compact]="mode === 'compact'">
	<lua-icone [class.majoration-disabled]="disabled" color="CouleurPrimaire" [mode]="getIconMode()"
		[width]="getIconSize()" [height]="getIconSize()" [iconName]="getMajorationDetails().iconName"
		[customIconName]="getMajorationDetails().customIconeName" [isIcon]="!!getMajorationDetails().customIconeName">
	</lua-icone>
	<ng-container *ngIf="!icon">
		<div class="description-container">
			<p class="label" [class.with-information]="regles?.length > 0">{{ getMajorationDetails().label }}</p>
			<div *ngIf="mode === 'detailed'" class="description-end-container" [class.with-information]="regles?.length > 0">
				<lua-bouton-icone *ngIf="regles?.length > 0" iconName="info" (onClick)="showInfoMajoration($event)"
					mode="outlined"></lua-bouton-icone>
				<p *ngIf="price" class="price">{{ priceLabel | number:'1.2-2' }} €</p>
			</div>
		</div>
	</ng-container>
</div>